module.exports = __webpack_public_path__ + "img/confirm-bg.fc867db2.svg";